module.exports = {
  customer: 'halton',
  environment: 'production',
  isBetterCare: true,
  yourMoney: true,
  jobsVolunteering: false,
  googleAnalyticsId: 'G-STMQGPB989',
  robots: false,
  chatWidget: false,
  entitledToBaseUrl: 'https://haltonbettercare.entitledto.co.uk',
  entitledToReassessUrl: 'https://haltonbettercare.entitledto.co.uk/reassessbetteroff',
  requirePostcode: false,

  app: {
    home: 'https://halton.bettercare.org.uk'
  },
  serverBaseUrl: 'https://api-halton.bettercare.org.uk',
  api: {
    baseUrl: 'https://api-halton.bettercare.org.uk/internal/v1'
  },
  authGateway: 'https://account.halton.bettercare.org.uk',
  loginServices: [
    {name: 'kerp'},
    {name: 'phone'},
    {name: 'google', postLogoutUrl: 'https://accounts.google.com/Logout'},
    {name: 'facebook'},
    {name: 'agent'},
    {name: 'referenceNumber'}
  ],
  ui: {
    showJobSearchJournal: false,
    showOfflineForms: true,
    showAssessmentMutators: false,
    restrictions: {
      applications: false
    }
  },
  airbrake: {
    enabled: true,
    projectId: 131082,
    projectKey: 'facc9a060872b357453b677f15d319e3'
  }
};
